import { ArrowLeftIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowLeft = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <ArrowLeftIcon color={fill || stroke} size={Sizes[size]} {...rest} />;
};

ArrowLeft.displayName = 'ArrowLeft';
